import styled from 'styled-components';

export const SsoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 1rem;

  h1 {
    font: 700 1.5rem/1.8rem 'Roboto', sans-serif;
  }
`;

export const SsoAuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;

  .error {
    padding: 0.5rem;
    background-color: ${({ theme }: {theme: any}) => theme.themeLighter};
    color: ${({ theme }: {theme: any}) => theme.black};
  }
`;

export const SsoAuthContainerMobile = styled.div`
  max-width: 350px;
  width: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 1rem;

  h3 {
    text-align: center;
  }
`;

export const SsoCardContainer = styled.div`
  margin: 10px 5px 10px 0px;
  width: 100%;
  border-radius: 16px;
  background: ${(props) => props.theme.neutralLighter};
  box-shadow: inset 0 6px 0 0 ${(props) => props.theme.themePrimary};
  padding: 32px;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    font: 400 14px/18px 'Roboto', sans-serif;

    a {
      font: 400 14px/18px 'Roboto', sans-serif;
      color: ${({ theme }: {theme: any}) => theme.themePrimary};
    }
  }

  p.description {
    padding-bottom: 16px;
    border-bottom: 1px solid ${({ theme }: {theme: any}) => theme.themeLighter};
  }

  h2 {
    font: 400 16px/18px 'Roboto', sans-serif;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const SsoFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
  gap: 1rem;

  span {
    font: 400 14px/18px 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
  }
`;
